<template>
    <q-btn-dropdown v-model="menu" @mouseover.native="activatorHover = true" @mouseout.native="activatorHover = false"
                    :label="menuItems.name"
                    clickable @click="dropDownMainClick"
                    stretch flat dense no-caps
                    class="gt-sm q-pl-sm text-weight-regular"
                    content-class="no-border no-border-radius">

        <q-list :class="{'row' : full, 'q-pa-md' : full}" style="max-width: 600px"
                @mouseover.native="menuHover = true" @mouseout.native="menuHover = false">
            <q-item v-for="item in menuItems.items" :key="item.name"
                    class="menu items-center" :class="{'col-4' : full}"
                    :to="item.path"
                    clickable v-close-popup>
                <q-item-section class="q-pa-xs">
                    <q-item-label :class="{'text-weight-medium' : full}">{{ item.name }}</q-item-label>
                    <q-item-label v-if="item.description" caption>{{ item.description }}</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>

<script>
    import { debounce } from 'quasar';

    export default {
        name: 'q-btn-dropdown-menu',
        props: {
            hover: Boolean,
            full: {
                type: Boolean,
                default: false
            },
            menuItems: Object,
            debounceTime: {
                type: Number,
                default: 50,
            },
            mainClickPath: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                menu: false,
                activatorHover: false,
                menuHover: false,
                debounceMenu: null,
            };
        },
        methods: {
            checkMenu() {
                if (this.hover)
                    this.menu = this.activatorHover || this.menuHover;
            },
            dropDownMainClick() {
                if (this.mainClickPath)
                    this.$router.push(this.mainClickPath);
            },
        },
        watch: {
            menuHover() {
                this.debounceMenu();
            },
            activatorHover() {
                this.debounceMenu();
            },
        },
        created() {
            this.debounceMenu = debounce(this.checkMenu, this.debounceTime);
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .menu {
        border-left: 2px solid transparent;
    }

    .menu:hover {
        border-left: 2px solid $primary !important;
    }

    </style>
